export { default } from './BannerImageOnlyV2'
